export default __webpack_public_path__ + "static/media/Footer_location.220def2f.svg";